import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeComponent implements AfterViewInit {
  @Input({ required: true }) time: string;
  @Input() label: string;
  @Input() isDisabled: boolean;
  @Input() isRequired = false;

  @Output() timeChanged = new EventEmitter<string>();

  defaultLabel = $localize`:@@shared.timeComponent.lblTime:Time`;
  isValid = true;
  private internalTime: string;
  private isInitialized = false;

  ngAfterViewInit() {
    // Mark as initialized after view is ready
    setTimeout(() => {
      this.isInitialized = true;
    }, 100);
  }

  @HostListener('keydown.shift.+', ['$event'])
  stopEventPropagation(event: KeyboardEvent): void {
    event.stopPropagation();
  }

  @HostListener('focusout', ['$event.target'])
  onFocusOut() {
    // Only validate if component is fully initialized
    if (!this.isInitialized) {
      return;
    }

    this.isValid = !(
      this.isRequired && String.isNullOrWhiteSpace(this.internalTime)
    );
  }

  onChange($event: any): void {
    this.internalTime = $event;
    this.timeChanged.emit($event);
  }
}
